import HourlyView from "../components/HourlyView";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { DatePicker, DesktopDatePicker } from "@mui/x-date-pickers";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import { Button } from "@mui/material";
import Select from "@mui/material/Select";
import React from "react";
import moment from "moment";
import "moment-timezone";
import { useFetchData } from "../hooks/useFetchData";
import {
  useParams,
  useNavigate,
  Navigate,
  useLocation,
} from "react-router-dom";
import GridSkeleton from "../components/GridSkeleton";
import NoData from "../components/NoData";
import { getUniqueValues } from "../utils";
import { useEffect, useState, useMemo } from "react";
import { alphabeticalSort } from "../utils";
import axiosFetch from "../utils/axiosFetch";
import BackendChart from "../components/BackendChart";
import { LoadingButton } from "@mui/lab";
import { useCookies } from "react-cookie";
import { buildCsv } from "../utils/export";
import { AMAZON_SUBCATEGORY_ORDER, AMAZON_CATEGORY_ORDER } from "../utils/constants";

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const YEARS = [
  2022,
  2023
];

const SUBCATEGORY_ORDER = AMAZON_SUBCATEGORY_ORDER;

const RealTime = ({ name, api, isExternal }) => {
  const navigate = useNavigate();
  const [, setCookie] = useCookies(["tenantType"]);
  const location = useLocation();
  const { date: pDate, dashboard: pDashboard } = useParams();
  const apiURL = pDashboard ? `${api}/${name}/${pDashboard}` : `${api}/${name}`;
  const endPointURL = `${apiURL}/24Hours/${moment(pDate).format("YYYY-MM-DD")}`;
  const redirectURL = pDashboard
    ? `/${name}/${pDashboard}/realtime`
    : `/${name}/realtime`;
  const { status, data } = useFetchData({
    endpoint: endPointURL,
  });
  const [healthData, setHealthData] = useState([]);
  const [noActivityServices, setNoActivityServices] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [isMounted, setIsMounted] = useState(false);
  const [LoaderTo, setLoaderTo] = useState(true);
  const selectedService = sessionStorage.getItem("location");
  const [csvData, setCSVData] = useState();
  const [loadingCsvData, setLoadingCsvData] = useState(false);

  let timer;

  if (isMounted && selectedService) {
    const el = document.getElementById(selectedService);
    el?.scrollIntoView({
      behavior: "auto",
      block: "center",
    });
  }

  console.log(LoaderTo);
  console.log(status);

  useEffect(() => {
    setIsMounted(true);

    if(name !== "fidelity") {
      return;
    }

    const { token } = window.localStorage;
    const currentDay = moment(pDate).day();
    const isWeekDay = currentDay > 0 && currentDay < 6;
    const startDate =
      isWeekDay === 1
        ? moment(pDate).subtract(2, "days").format("YYYY-MM-DD")
        : moment(pDate).subtract(1, "days").format("YYYY-MM-DD");
    const endDate = moment(pDate).format("YYYY-MM-DD");
    const body = {
      startDate: `${startDate} 18:00:00`,
      endDate: `${endDate} 09:00:00`,
    };

    const postEndPointURL = "partner/fidelity/filehealth";
    axiosFetch
      .post(postEndPointURL, body, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setHealthData(res.data.filter(data => !data.category.includes("CT")));
      });

    return () => {
      clearTimeout(timer);
      if (sessionStorage.getItem("location")) {
        sessionStorage.removeItem("location");
      }
      setLoaderTo(false);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    console.log("setting tenant", name);
    window.localStorage.setItem("tenantType", name);
  }, [name]);

  useEffect(() => {
    const { token } = window.localStorage;
    axiosFetch
      .get(`${apiURL}/realTime`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setServiceData(res.data);
      });
  }, [data, apiURL]);

  useEffect(() => {
    if (Object.keys(serviceData).length && Array.isArray(data)) {
      const availableServices = [...new Set(data.map((d) => d.event_label))];
      const noServices = serviceData.result.filter(
        ({ event_label }) => !availableServices.includes(event_label)
      );
      setNoActivityServices(noServices);
    }
  }, [serviceData, data]);

  const noServicesByCategory = useMemo(() => {
    return {
      nirvana: noActivityServices.filter(
        ({ category }) => category === "nirvana"
      ),
      trancore: noActivityServices.filter(
        ({ category }) => category === "trancore"
      ),
      acquisition: noActivityServices.filter(
        ({ category }) => category === "acquisition"
      ),
      api: noActivityServices.filter(({ category }) => category === "api"),
      mobile: noActivityServices.filter(
        ({ channel_name }) => channel_name === "mobile"
      ),
      olb: noActivityServices.filter(
        ({ channel_name }) => channel_name === "olb"
      ),
      backend: noActivityServices.filter(
        ({ channel_name }) => channel_name === "backend"
      ),
       usb_api: noActivityServices.filter(
        ({ category }) => category === "usb_api"
      ),
      partner_api: noActivityServices.filter(
        ({ category }) => category === "partner_api"
      ),
      olb: noActivityServices.filter
      (({ category }) => category === "olb"),
      spend_management: noActivityServices.filter(
        ({ category }) => category === "spend_management"
      ),
    };
  }, [noActivityServices]);

  const [trancoreData, setTrancoreData] = useState([]);
  const [nirvanaData, setNirvanaData] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [acquisitionData, setAcquisitionData] = useState([]);
  const [mobileData, setMobileData] = useState([]);
  const [olbData, setOlbData] = useState([]);
  const [backendData, setBackendData] = useState([]);
  const [usbApiData, setUsbApiData] = useState([]);
  const [partnerApiData, setPartnerApiData] = useState([]);
  const [spendManagementData, setSpendManagementData] = useState([]);
  const [exportDate, setExportDate] = useState(moment());

  useEffect(() => {
    if (data.length) {
      const olbData1 = data.filter((row) => row.category === "olb");
      setOlbData(olbData1);

      const trancoreData1 = data.filter((row) => row.category === "trancore");
      setTrancoreData(trancoreData1);

      const nirvanaData1 = data.filter((row) => row.category === "nirvana");
      setNirvanaData(nirvanaData1);

      const apiData1 = data.filter((row) => row.category === "api");
      setApiData(apiData1);

      const acquisitionData1 = data.filter(
        (row) => row.category === "acquisition"
      );
      const usbApiData1 = data.filter((row) => row.category === "usb_api");
      setUsbApiData(usbApiData1);

      const partnerApiData1 = data.filter((row) => row.category === "partner_api");
      setPartnerApiData(partnerApiData1);

      const spendManagementData1 = data.filter((row) => row.category === "spend_management");
      setSpendManagementData(spendManagementData1);

      setAcquisitionData(acquisitionData1);
      const mobileData1 = data.filter((row) => row.channel_name === "mobile");
      setMobileData(mobileData1);
      const backendData1 = data.filter((row) => row.channel_name === "backend");
      setBackendData(backendData1);
      // timer = setTimeout(() => {
      // setLoaderTo(false);
      // }, 3000);
    }
    setLoaderTo(false);
  }, [data, status]);

  const tableData = useMemo(() => {
    const verifyData = (list, noServicesList) => {
      let combinedList = [];
      if (list.length) {
        list.forEach((realTimeData) => {
          const inactiveService = noServicesList.filter(
            (item) =>
              item.category === realTimeData.category &&
              item.event_label !== realTimeData.event_label
          );
          combinedList = [...combinedList, realTimeData, ...inactiveService];
        });
      } else {
        combinedList = [...combinedList, ...noServicesList];
      }
      return [...new Set(combinedList)];
    };
    return {
      trancore: verifyData(trancoreData, noServicesByCategory.trancore),
      nirvana: verifyData(nirvanaData, noServicesByCategory.nirvana),
      api: verifyData(apiData, noServicesByCategory.api),
      mobile: verifyData(mobileData, noServicesByCategory.mobile),
      usb_api: verifyData(usbApiData, noServicesByCategory.usb_api),
      partner_api: verifyData(partnerApiData, noServicesByCategory.partner_api),
      olb: verifyData(olbData, noServicesByCategory.olb),
      acquisition: verifyData(
        acquisitionData,
        noServicesByCategory.acquisition
      ),
      backend: verifyData(backendData, noServicesByCategory.backend),
      spend_management: verifyData(spendManagementData, noServicesByCategory.spend_management),
    };
  }, [
    noServicesByCategory,
    trancoreData,
    nirvanaData,
    apiData,
    mobileData,
    usbApiData,
    partnerApiData,
    acquisitionData,
    olbData,
    backendData,
    spendManagementData,
  ]);

  // Derive the transaction label format from actual DB data so all services render consistently.
  // If any row uses "Transactions(Success+Error)", that format is used for all services.
  const transactionLabel = useMemo(() => {
    const allRows = Object.values(tableData).flat();
    const withParens = allRows.find(
      (row) => row.status_name === "transaction" && row.status_label?.includes("(")
    );
    if (withParens) return withParens.status_label;
    const plain = allRows.find((row) => row.status_name === "transaction");
    return plain?.status_label || "Transactions";
  }, [tableData]);

  const formatCSVdata = (response) => {
    if (!response || !Array.isArray(response) || response.length === 0) {
      return { headers: [], data: [] };
    }

    if (name === 'amazon') {
      const sorted = [...response].sort((a, b) => {
        // Order by date
        if (a.date && b.date && a.date !== b.date) return a.date.localeCompare(b.date);
        // Then by channel
        if ((a.channel_name || '') !== (b.channel_name || '')) return (a.channel_name || '').localeCompare(b.channel_name || '');
        // Then by category
        if ((a.category || '') !== (b.category || '')) return (a.category || '').localeCompare(b.category || '');
        // Then by subcategory (custom order)
        const indexA = SUBCATEGORY_ORDER.indexOf(a.subcategory_label);
        const indexB = SUBCATEGORY_ORDER.indexOf(b.subcategory_label);
        if (indexA !== -1 && indexB !== -1) {
          if (indexA !== indexB) return indexA - indexB;
        } else if (indexA !== -1) return -1;
        else if (indexB !== -1) return 1;
        else if ((a.subcategory_name || '') !== (b.subcategory_name || '')) return (a.subcategory_name || '').localeCompare(b.subcategory_name || '');
        // Then by event
        if ((a.event_label || '') !== (b.event_label || '')) return (a.event_label || '').localeCompare(b.event_label || '');
        // Then by status
        if ((a.status || '') !== (b.status || '')) return (a.status || '').localeCompare(b.status || '');
        return 0;
      });
      const headers = Object.keys(sorted[0]);
      return { headers, data: sorted };
    }

    const headers = Object.keys(response[0]);
    return {
      headers,
      data: response
    };
  };


  useEffect(() => {
    if (exportDate) {
      const { token } = window.localStorage;

      setLoadingCsvData(true);

      axiosFetch
        .get(`${apiURL}/Month/${exportDate.format("MMMM")} ${exportDate.format("YYYY")}`, {
          headers: { Authorization: `Bearer ${token}` },
        }).then((res) => {
        if (res.statusText === "OK" && Array.isArray(res.data)) {
          const formatted = formatCSVdata(res.data); // 
          setCSVData(formatted); //
        } else {
          setCSVData({ headers: [], data: [] });
        }
        setLoadingCsvData(false);
      })
        .catch((error) => {
          setLoadingCsvData(false);
          console.log("Error fetching CSV data:", error);
        })
    }
  }, [apiURL, exportDate]);

  if (!pDate) {
    if (location.state && location.state.eventLabel) {
      sessionStorage.setItem("location", location.state?.eventLabel);
    }
    navigate(`${redirectURL}/${moment().format("YYYY-MM-DD")}`);
  }
  const navigateReal = (newDate) => {
    navigate(`${redirectURL}/${moment(newDate).format("YYYY-MM-DD")}`);
  };
  if (!moment(pDate).isValid()) {
    return <Navigate to="/error" />;
  }
  if (status === "rejected") {
    return <Navigate to="/error" />;
  }
  if (status === "unauthorized") {
    return <Navigate to="/login" />;
  }

  const getHeading = (header) => {
    if (header === "api") {
      return header?.toUpperCase() + " Services";
    } else if (header === "nirvana") {
      return "Partner Card Servicing Portal (PCSP)"
    } else if (header === "olb") {
      return "Online Banking (OLB)"
    } else if(header==="usb_api"){
      return "USB Hosted API/Webhooks"
    } else if(header==="partner_api"){
      return "Partner Hosted API/Webhooks"
    }
    else if(header==="spend_management"){
      return "Spend Management"
    }
    else if(name==='amazon' && header==="acquisition"){
      return "Acquisition Health Status";
    }
    else {
      const row = Array.isArray(data) ? data.find(r => r.category === header || r.channel_name === header) : null;
      return row?.category_label || header?.charAt(0).toUpperCase() + header.slice(1) + " Services";
    }
  };

  const defaultExternalServices = ["olb", "trancore", "nirvana", "api", "acquisition", "usb_api", "partner_api"];

  const externalServices = name === 'amazon'
    ? [...new Set([...AMAZON_CATEGORY_ORDER, ...defaultExternalServices.filter(s => !AMAZON_CATEGORY_ORDER.includes(s))])]
    : defaultExternalServices;

  const downloadCSV = () => {
  // if (csvData.data.length === 0 && csvData.headers.length === 0) {
  //   return;
  // }
  let content = buildCsv(csvData.headers, csvData.data);
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `${exportDate.format("MMMM")}-${exportDate.format("YYYY")}.csv`
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

  const onExportDateChange = (value) => {
    setExportDate(value);
  }

  return LoaderTo || status === "loading" ? (
    <>
      <div
        style={{
          align: "center",
          position: "static",
          marginTop: "100px",
          width: "834px",
          paddingLeft: "392px",
        }}
      >
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </div>
    </>
  ) : (
    <Grid container justifyContent="center" sx={{ pl: 10, mt: 0 }} spacing={1}>
      <Grid item xs={12} md={10} bgcolor="white" position="fixed" width={10000}>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          {status === "loading" ? (
            <Skeleton />
          ) : (
            <Box sx={{ display: "flex" }}>
              {isExternal ? (
                <>
                  <DatePicker
                      sx={{ ml: "auto" }}
                      label={
                          'Month Year'
                      }
                      views={
                          ['year', 'month']
                      }
                      value={exportDate}
                      onChange={onExportDateChange}
                  />

                  <LoadingButton
                    variant="contained"
                    style={{ marginRight: "10px", width: "175px" }}
                    disabled={!exportDate || !csvData ? true : false}
                    loading={loadingCsvData}
                    onClick={downloadCSV}
                  >
                    Download CSV
                  </LoadingButton>
                </>
              ) : null}
              <DesktopDatePicker
                label="Status Date"
                value={moment(pDate)}
                onChange={navigateReal}
                renderInput={(params) => <TextField variant="outlined" {...params} />}
              />
            </Box>
          )}
        </Box>
      </Grid>
      <Grid item xs={12} md={10} mt={10}>
        {status === "loading" ? (
          <GridSkeleton rows={9} cols={9} />
        ) : data.length === 0 ? (
          <NoData />
        ) : isExternal ? (
          <Stack spacing={2}>
            {externalServices.map((service) => {
              return (
                tableData[service]?.length === 0 ? 
                  <></>
                  : name === 'amazon' ? (
                  <>
                    {(() => {
                      const sortedData = [...tableData[service]].sort((a, b) => {
                        const indexA = SUBCATEGORY_ORDER.indexOf(a.subcategory_label);
                        const indexB = SUBCATEGORY_ORDER.indexOf(b.subcategory_label);
                        if (indexA !== -1 && indexB !== -1) {
                          if (indexA !== indexB) return indexA - indexB;
                        } else if (indexA !== -1) return -1;
                        else if (indexB !== -1) return 1;
                        else {
                          const subA = a.subcategory_id ?? 0;
                          const subB = b.subcategory_id ?? 0;
                          if (subA !== subB) return subA - subB;
                        }
                        return alphabeticalSort(a, b, "event_label");
                      });
                      const subcategories = [
                        ...new Map(
                          sortedData.map((item) => [item.subcategory_id, item])
                        ).values(),
                      ];
                      return subcategories.map((sub) => {
                        const subServices = sortedData.filter(
                          (row) => row.subcategory_id === sub.subcategory_id
                        );
                        return (
                          <>
                            {sub.subcategory_label && (
                              <h3 style={{ textAlign: "center", marginTop: "20px" }}>
                                {getHeading(service) === sub.subcategory_label
                                  ? sub.subcategory_label
                                  : `${getHeading(service)} - ${sub.subcategory_label}`}
                              </h3>
                            )}
                            {getUniqueValues(subServices, "event_name").map(
                              (unique) => {
                                const rows = subServices.filter(
                                  (row) => row.event_name === unique
                                );
                                return (
                                  <div>
                                    {rows.length ? (
                                      <div>
                                        <HourlyView
                                          data={rows}
                                          title={rows[0].event_label}
                                          key={rows[0].event_name}
                                          transactionLabel={transactionLabel}
                                        />
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                );
                              }
                            )}
                          </>
                        );
                      });
                    })()}
                  </>
                ) : (
                  <>
                    <h2 style={{ textAlign: "center", marginTop: "20px" }}>
                      {getHeading(service)}
                    </h2>
                    {getUniqueValues(
                      tableData[service].sort((a, b) => {
                        if (service === "olb") {
                          const subA = a.subcategory_id ?? 0;
                          const subB = b.subcategory_id ?? 0;
                          if (subA !== subB) return subA - subB;
                        }
                        return alphabeticalSort(a, b, "event_label");
                      }),
                      "event_name"
                    ).map((unique) => {
                      const rows = tableData[service].filter(
                        (row) => row.event_name === unique
                      );

                      return (
                        <div>
                          {rows.length ? (
                            <div>
                              <HourlyView
                                data={rows}
                                title={rows[0].event_label}
                                key={rows[0].event_name}
                                transactionLabel={transactionLabel}
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      );
                    })}
                  </>
                )
              );
            })}

            {pDashboard === "prod" && name==='fidelity' &&
              <>
                <h2 style={{ textAlign: "center", marginTop: "20px" }}>
                  File Health Services
                </h2>
                {getUniqueValues(
                  healthData.sort((a, b) => alphabeticalSort(a, b, "category")),
                  "category"
                ).map((unique) => {
                  const row = healthData.find((row) => row.category === unique);
                  return (
                    <div>
                      {row ? (
                        <div id={row.category}>
                          <Paper variant="outlined">
                            <Paper
                              sx={{
                                px: 2,
                                py: 1,
                                bgcolor: "secondary.main",
                                color: "common.white",
                              }}
                            >
                              <Stack direction="row" spacing={1}>
                                <Typography variant="subtitle1">
                                  {`${row.category}${row?.monthly === 1 ? " - Monthly" : ""}`}
                                </Typography>
                              </Stack>
                            </Paper>
                            <TableContainer
                              component={Paper}
                              sx={{
                                boxShadow: 0,
                                borderTop: 1,
                                borderColor: "grey.300",
                                borderRadius: 0,
                              }}
                            >
                              <Table>
                                <TableBody>
                                  <TableRow key={row.fileName}>
                                    <TableCell>
                                      Filename: <span>{row.fileName}</span>
                                    </TableCell>
                                  </TableRow>
                                  <TableRow key={row.TransactionDate}>
                                    <TableCell>
                                      Last Transaction Date:{"       "}
                                      <span>
                                        {moment(row?.TransactionDate)
                                          .tz("America/Chicago")
                                          .format("dddd, MMMM Do YYYY, h:mm:ss a")}
                                      </span>
                                    </TableCell>
                                  </TableRow>
                                  <TableRow key={row.color}>
                                    <TableCell>
                                      Status:{" "}
                                      <span>
                                        <Typography
                                          display="inline"
                                          variant="subtitle2"
                                          color={
                                            row.color === "RED" ? "red" : "green"
                                          }
                                        >
                                          {row.color === "RED"
                                            ? "No files processed in last 24Hrs"
                                            : "successful"}
                                        </Typography>
                                      </span>
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Paper>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </>
            }
          </Stack>
        ) : (
          <Stack>
            {getHeading(name) === "Backend Services" ? (
              <BackendChart
                type={apiURL}
                loader={LoaderTo}
                endPointURL={endPointURL}
                selectedDate={pDate}
              />
            ) : null}
            <h2 style={{ textAlign: "center", marginTop: "20px" }}>
              {getHeading(name)}
            </h2>
            {getUniqueValues(
              tableData[name].sort((a, b) =>
                alphabeticalSort(a, b, "event_label")
              ),
              "event_name"
            ).map((unique) => {
              const rows = tableData[name].filter(
                (row) => row.event_name === unique
              );
              return (
                <div>
                  {rows.length ? (
                    <div>
                      <HourlyView
                        data={rows}
                        title={rows[0].event_label}
                        key={rows[0].event_name}
                        transactionLabel={transactionLabel}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              );
            })}
          </Stack>
        )}
      </Grid>
    </Grid>
  );
};

export default RealTime;
